export default function SocialMediaManagement() {
  return (
    <div>
      <h1 className="page-title">Social Media Management</h1>
      <div>This page is under construction</div>
    </div>
  );
}
